const Logout = () => {
    window.location.href = "/";
    localStorage.clear();
    sessionStorage.clear();
    return null;
  };
  
  export default Logout;